import { useState } from "react";

/* CSS */
import styles from './OAuth.module.css';

/* Icons */
import google_unclicked from '../../assets/icons/google_unclicked.svg';
import google_clicked from '../../assets/icons/google_clicked.svg';
import facebook_unclicked from '../../assets/icons/facebook_unclicked.svg';
import facebook_clicked from '../../assets/icons/facebook_clicked.svg';

/* Components */
// import ConfirmationModal from '../cards/ConfirmationModal';

// const API_BASE_URL = window.location.hostname === 'localhost'
//     ? 'http://localhost:5000/api'
//     : '/api';

const OAuth = ({ dividerText, next }) => {
    const [hoverGoogle, setHoverGoogle] = useState(false);
    const [hoverFacebook, setHoverFacebook] = useState(false);
    // TODO: Apple Sign-In
    // const [hoverApple, setHoverApple] = useState(false);
    // const [showAppleModal, setShowAppleModal] = useState(false);
    // const [appleInterestSubmitted, setAppleInterestSubmitted] = useState(false);

    // const handleAppleModalClose = () => {
    //     setShowAppleModal(false);
    //     setAppleInterestSubmitted(false);
    // };

    // const handleAppleInterestYes = async () => {
    //     try {
    //         await fetch(`${API_BASE_URL}/feature-interest`, {
    //             method: 'POST',
    //             headers: { 'Content-Type': 'application/json' },
    //             body: JSON.stringify({ feature: 'apple_oauth' })
    //         });
    //     } catch {
    //         // Silent fail — not critical to the user flow
    //     }
    //     setAppleInterestSubmitted(true);
    // };

    return (
        <>
            {/* ------- Divider ------- */}
            <div className={styles.authDivider}>
                <span className={styles.authDividerLine} />
                <span className={styles.authDividerText}>{dividerText}</span>
                <span className={styles.authDividerLine} />
            </div>

            <div className={styles.authSocialButtons}>
                <button
                    type="button"
                    className={`${styles.authSocialButton} ${styles.authSocialGoogle}`}
                    onMouseEnter={() => setHoverGoogle(true)}
                    onMouseLeave={() => setHoverGoogle(false)}
                    onClick={() => {
                        const backendUrl = window.location.hostname === 'localhost'
                            ? 'http://localhost:5000'
                            : '';
                        const suffix = next ? `?next=${encodeURIComponent(next)}` : '';
                        window.location.href = backendUrl + '/api/auth/google' + suffix;
                    }}
                >
                    <img
                        src={hoverGoogle ? google_clicked : google_unclicked}
                        alt="Google icon"
                    />
                </button>

                <button
                    type="button"
                    className={`${styles.authSocialButton} ${styles.authSocialFacebook}`}
                    onMouseEnter={() => setHoverFacebook(true)}
                    onMouseLeave={() => setHoverFacebook(false)}
                    onClick={() => {
                        const backendUrl = window.location.hostname === 'localhost'
                            ? 'http://localhost:5000'
                            : '';
                        const suffix = next ? `?next=${encodeURIComponent(next)}` : '';
                        window.location.href = backendUrl + '/api/auth/facebook' + suffix;
                    }}
                >
                    <img
                        src={hoverFacebook ? facebook_clicked : facebook_unclicked}
                        alt="Facebook icon"
                    />
                </button>

                {/* <button
                    type="button"
                    className={`${styles.authSocialButton} ${styles.authSocialApple}`}
                    onMouseEnter={() => setHoverApple(true)}
                    onMouseLeave={() => setHoverApple(false)}
                    onClick={() => setShowAppleModal(true)}
                >
                    <img
                        src={hoverApple ? apple_clicked : apple_unclicked}
                        alt="Apple icon"
                    />
                </button> */}
            </div>

            {/* <ConfirmationModal
                isOpen={showAppleModal}
                onClose={handleAppleModalClose}
                title={appleInterestSubmitted
                    ? "Thanks for letting us know!"
                    : "Apple Sign-In isn't available yet:("
                }
                message={appleInterestSubmitted
                    ? <>Btw, you can sign in with <strong>Google</strong> or <strong>Facebook</strong>🫡</>
                    : <>Please vote if <strong>you'd like Apple sign-in to be added</strong> 🙏🙇‍♀️</>
                }
                onConfirm={appleInterestSubmitted ? handleAppleModalClose : handleAppleInterestYes}
                confirmText={appleInterestSubmitted ? "Got it!" : "Yes, I'd love it!"}
                cancelText="No thanks"
                showCancel={!appleInterestSubmitted}
                isSuccess={appleInterestSubmitted}
                customWidth="450px"
            /> */}
        </>
    );
};

export default OAuth;